import AWS from 'aws-sdk'
export const awsRegion = 'ap-southeast-2'
export const cognitoRegion = 'ap-southeast-2'
export const cognitoUserPoolId = 'ap-southeast-2_fTO2irSd9'
export const cognitoIdentityPoolId = 'ap-southeast-2:a3f4e39f-db51-4794-b158-c90b9af40e2c'
export const cognitoClientId = '36f4tc6nn0erd52fbuegvjj0n7'

AWS.config.region = cognitoRegion



// WEBPACK FOOTER //
// ./src/services/aws.js